export default "__VITE_ASSET__DwuqWMxX__"